
import {
  defineComponent,
  onMounted,
  PropType,
  ref,
  shallowRef,
  toRef,
  watch,
  inject,
  computed,
} from "vue";
import { IBulkDelete } from "@/interfaces/iPageModel";
import Datatable from "@/components/kt-datatable/KTDatatable.vue";
import { TranslationService } from "@/core/services/TranslationService";
import { INNER_PAGE_ROWS_PER_PAGE, usePagination } from "@/helpers/pagination";
import { ISiteDeviceModel } from "@/interfaces/iSite";
import VZDeleteModal from "@/components/content/VZDeleteModal.vue";
import { hasPermission } from "@/core/services/permission.service";
import {
  SiteDeviceTableBulkDelete,
  SiteDeviceTableFilters,
  SiteDeviceTableHeaders,
} from "../siteDataTableOptions";
import { useToast } from "vue-toastification";
import { ITabConfig } from "@/interfaces/iTabConfig";
import { SITE_TABS } from "@/views/site/siteDataTableOptions";
import { DrawerComponent } from "@/assets/ts/components";
import PreviewLink from "@/components/typography/PreviewLink.vue";
import DeviceDetailModal from "@/views/site/modal/DeviceDetailModal.vue";
import { Emitter } from "mitt";
import { LocationAPI } from "@/services/api/Location.service";
import { ISiteLocationDevice } from "@/interfaces/iLocation";
import { SiteApi } from "@/services/api/Site.service";
import { Modal } from "bootstrap";
import { debounce } from "lodash";
interface ITabsEmit {
  tabs: ITabConfig[];
  title: string;
  icon?: string;
}
type Events = {
  VZTabsUpdate: ITabsEmit;
};
export default defineComponent({
  props: {
    data: { type: Object as PropType<ISiteDeviceModel>, required: true },
    openDrawer: { type: Boolean, default: false },
    isActive: { type: Boolean, default: false },
  },
  components: {
    Datatable,
    VZDeleteModal,
    PreviewLink,
    DeviceDetailModal,
  },
  setup(props) {
    const t = (key: string) => {
      return TranslationService.translate(key);
    };
    const dataProp = toRef(props, "data");
    const openDrawer = toRef(props, "openDrawer");
    const { page, total } = usePagination();
    const rowsPerPage = ref(INNER_PAGE_ROWS_PER_PAGE);
    const loading = ref(false);
    const showSearch = true;
    const tableData = ref<any[]>([]);
    const selectedForAction = ref<Partial<ISiteLocationDevice> | any>({});
    const localPreference = ref({});
    const showDetailDialog = ref<any>(false);
    const bulkDelete = ref<IBulkDelete>(SiteDeviceTableBulkDelete());
    const tableHeader = ref(SiteDeviceTableHeaders());
    const tableFilter = ref(SiteDeviceTableFilters());
    const showDeleteDialog = ref<any>(false);
    const toast = useToast();
    const deviceDeleteMessage = t("pages.site.deviceDeleteMessage");
    const emitter: Emitter<Events> | undefined = inject("emitter");
    const tabs = shallowRef<ITabConfig[]>(SITE_TABS());
    const viewName = "siteDevice";
    const deviceDetail = ref({});
    const Datatable = ref();
    let permissionModel = ref<any>({
      create: "VYZOR:BUSINESS:SITE:CREATE",
      delete: "VYZOR:BUSINESS:SITE:DELETE",
      update: "VYZOR:BUSINESS:SITE:UPDATE",
    });

    onMounted(async () => {
      // await refreshList();
      loading.value = true;
    });
    const syncQuery = async (params?: Record<string, number | string>) => {
      queryUpdate(dataProp.value.webId, params);
    };

    const queryUpdate = async (
      webId: number,
      params?: Record<string, number | string>
    ) => {
      try {
        loading.value = true;
        if (!params || !params.sort) {
          params = {
            ...params,
            sort: "createdDate,desc",
          };
        }
        const data = await SiteApi.getInstance().getSiteDeviceList(
          dataProp.value.webId,
          {
            ...params,
          }
        );
        localPreference.value = { ...params };
        tableData.value = [...data.content];
        total.value = data.totalElements;
        rowsPerPage.value = data.size;
        page.value = ++data.number;
      } finally {
        loading.value = false;
      }
    };

    const openDeleteDialog = (device) => {
      console.log(device);
      selectedForAction.value = device;
      showDeleteDialog.value = true;
    };
    const onBulkDelete = async (deviceIds) => {
      showDeleteDialog.value = false;
      try {
        await LocationAPI.getInstance()
          .deleteSiteDevice(deviceIds)
          .then(() => {
            toast.success(deviceDeleteMessage);
          })
          .catch((err) => {
            console.error(err);
          });

        refreshList();
      } catch (e) {
        //
      }
    };
    const refreshList = () => {
      showDeleteDialog.value = false;
      queryUpdate(dataProp.value.webId, { ...localPreference.value });
    };
    const openDetailModal = async (site) => {
      tabs.value = tabs.value.map((tab) => {
        return { ...tab, props: { data: site } };
      });
      emitter?.emit("VZTabsUpdate", {
        tabs: tabs.value,
        title: site.name,
        icon: "bi bi-diagram-3 fs-2 text-primary",
      });
      if (DrawerComponent?.getInstance("vz_detail_drawer")?.isShown()) {
        DrawerComponent?.getInstance("vz_detail_drawer")?.hide();
      }
      DrawerComponent?.getInstance("vz_detail_drawer")?.toggle();
    };
    // const data = await SiteApi.getInstance().getDevice(+webId);
    const openDeviceDetail = async (device) => {
      try {
        showDetailDialog.value = true;
        deviceDetail.value = await SiteApi.getInstance().getDevice(+device);
        const modal = new Modal(
          document?.getElementById(`device_detail_modal`) as HTMLElement
        );
        modal?.show();
      } catch (e) {
        //
      }
    };

    const webId = computed(() => props.data?.webId);
    let lastFetchedWebId = null;
    const debouncedQueryUpdate = debounce(async (webId) => {
      if (webId !== lastFetchedWebId) {
        tableData.value = [];
        lastFetchedWebId = webId;
        rowsPerPage.value = INNER_PAGE_ROWS_PER_PAGE;
        queryUpdate(+webId, {
          page: page.value - 1,
          size: rowsPerPage.value,
        });
        if (Datatable.value.VZFilter) {
          Datatable.value.VZFilter.getSavedFilterList();
        }
      }
    }, 300);

    watch(
      () => props.isActive,
      async (isActive) => {
        if (isActive && dataProp.value.webId) {
          // await queryUpdate(dataProp.value.webId, {
          //   page: page.value - 1,
          //   size: rowsPerPage.value,
          // });
          loading.value = true;
          if (Datatable.value?.VZFilter) {
            await Datatable.value.VZFilter.getAppliedFilters();
          }
        } else {
          tableData.value = [];
        }
      }
    );
    return {
      bulkDelete,
      tableData,
      tableHeader,
      tableFilter,
      showSearch,
      page,
      total,
      rowsPerPage,
      loading,
      selectedForAction,
      syncQuery,
      refreshList,
      viewName,
      onBulkDelete,
      openDetailModal,
      t,
      tabs,
      permissionModel,
      hasPermission,
      openDeviceDetail,
      showDetailDialog,
      deviceDetail,
      showDeleteDialog,
      Datatable,
      openDeleteDialog,
    };
  },
});
